import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Nav,
  Card,
  Spinner,
} from "react-bootstrap";
import NumberFormat from "react-number-format";
import { FaShieldAlt, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import safeHtml from "../../utils/safeHtml";
import fetchJsonWithFallback from "../../utils/fetchJsonWithFallback";
import { CDN_INCLUDES, CDN_ASSETS } from "../../utils/cdn";
import localContactUs from "../../data/contactUs.json";
import "./index.css";

//  Custom CSS
const treasury = {
  opacity: 0,
  position: "absolute",
};
// End of Custom CSS

function serialize(form) {
  let inputs = form.elements;
  let testArray = {};
  for (let i = 0; i < inputs.length; i++) {
    testArray[inputs[i].id] = inputs[i].value;
  }
  return testArray;
}
function trim(theStr) {
  return theStr.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
  var retVal = "";
  var okChars = "0123456789";
  var tmpVal = trim(inVal);
  var curChar = "";
  var isDotFound = false;

  if (tmpVal !== "") {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);

      if (okChars.indexOf(curChar) !== -1) {
        if (!isDotFound && curChar === "." && isDouble) {
          isDotFound = true;
          retVal = retVal + ".";
        }

        if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }

  return retVal;
}

function ContactUs() {
  const [validated, setValidated] = useState(false);

  const [showTY, setTYModal] = useState(false);
  const [showFail, setFailModal] = useState(false);
  const [showLoading, setLoading] = useState(false);
  const [consent, setConsent] = useState(true);
  const [contactName, setContactName] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [zipcodeError, setZipCodeError] = useState("");
  const [city, setCity] = useState("");
  const [cityOptions, setCityOptions] = useState("");
  const [state, setState] = useState("");
  const [stateList, setStateList] = useState("");
  const [statesOptions, setStatesOptions] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [contactUs, setContactUs] = useState(localContactUs);
  // propertyState used only locally inside updateZipCode — no need for component-level let
  const handleTelephoneNumber = (evt) => {
    var tmpVal = trim(getNumbers(evt.currentTarget.value, false, "01"));
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
        456, 555, 900,
        100, 101, ..., 199
        211, 311, ..., 911  ***811 removed
        370, 371, ..., 379
        960, 961, ..., 969
        800, 801, ..., 855  ***removed
        866, 877, 888, 800855
        */
    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = "";
      return;
    }

    var curChar = "";

    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = "";

    if (areaCode !== "") retVal += "(" + areaCode + ")";

    if (firstThree !== "") {
      retVal += " " + firstThree;
      if (firstThree.length === 3) retVal += "-";
    }

    if (lastFour !== "") retVal += lastFour;

    if (extension !== "") retVal += " x" + extension;

    setPhoneNumber(retVal);
  };

  function updateZipCode(propZipCode) {
    setZipCode(propZipCode);

    if (propZipCode.length === 5) {
      axios
        .get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + propZipCode, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
        const propertyState = stateList.filter(
            (state) => state.code === response.data.state
          );
          if (!propertyState || !propertyState.length) {
            setZipCodeError(
              `We are not accepting applications for the state of ${response.data.state}`
            );
          } else {
            setState(response.data.state);
            setCityOptions(
              response.data.cities.map((item, index) => (
                <option key={index} value={item.code}>
                  {item.name}
                </option>
              ))
            );
          }
        })
        .catch((e) => {
          setZipCodeError(e?.response?.data?.error || "An error occurred while validating the zip code.");
        });
    }

    if (propZipCode.length < 5) {
      setZipCodeError("");
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setLoading(true);
      const data = document.querySelector("#contactForm");
      const getData = serialize(data);
      axios
        .post(
          `https://kk9ynwj5wg.execute-api.us-east-1.amazonaws.com/master/`,
          getData
        )
        .then((res) => {
          if (res.data.statusCode === 200) {
            let submitNotes = document.getElementById("contactForm");
            submitNotes.classList.remove("was-validated");
            document.getElementById("contactForm").reset();
            setPhoneNumber("");
            setTYModal(true);
          } else {
            setFailModal(true);
          }
          setLoading(false);
        })
        .catch(function (error) {
          setFailModal(true);
          setLoading(false);
        });
    }
    setValidated(true);
  };

  useEffect(() => {
    // Get state from public endpoint
    axios
      .post(
        process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_LIST,
        { domain: "https://sunwestmortgage.com/", companyCode: "SUNWST000" },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((response) => {
        // Set States list
        setStateList(response.data);
        // Set the dropdown state list option.

        setStatesOptions(
          response.data.map((item, index) => (
            <option key={index} value={item.code}>
              {item.name}
            </option>
          ))
        );
      })
      .catch((err) => {
        console.error("Failed to fetch state list", err);
      });

    /* Get client IP and geolocation(maxmind API) Task LRTV-3 */
    axios
      .post(
        process.env.REACT_APP_MAXMIND,
        {},
        {
          headers: { "Content-Type": "application/json" },
          timeout: 5000,
        }
      )
      .then((response) => {
        if (
          response.data !== "IP Not Available" &&
          response.data !== "Invalid Country"
        ) {
          let zipcode = response.data.zipcode;

          if (zipcode) {
            axios
              .get(
                process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipcode,
                {
                  headers: { "Content-Type": "application/json" },
                  timeout: 5000,
                }
              )
              .then((response) => {
                setState(response.data.state);
                setCityOptions(
                  response.data.cities.map((item, index) => (
                    <option key={index} value={item.code}>
                      {item.name}
                    </option>
                  ))
                );
              })
              .catch((err) => {
                console.error("Failed to fetch city options", err);
              });
          }
        } else {
          console.log(response.data); // Show Error message from lambda function
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    let isMounted = true;
    fetchJsonWithFallback(CDN_INCLUDES + "contactUs.json", localContactUs).then(
      (data) => {
        if (isMounted) setContactUs(data);
      }
    );
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <React.Fragment>
      <div className="contact-page" style={{ backgroundImage: `url(${CDN_ASSETS}message-us-bg.webp)` }}>
        <Container>
        <Row className="justify-content-center">
        <Col xs={12} className="contact-card">
          <div className="contact-card__banner">
            {/* <FaShieldAlt className="contact-card__banner-icon" /> */}
            <p className="contact-card__banner-text">
              {safeHtml(contactUs.bannerText)}
            </p>
          </div>

          <div className="contact-card__header">
            <h1 className="contact-card__title">{safeHtml(contactUs.title)}</h1>
            <p className="contact-card__intro">{safeHtml(contactUs.intro)}</p>
            <hr className="contact-card__divider" />
          </div>

          {/* <p className="contact-card__required-note">
            <span className="contact-card__required-asterisk">*</span>{" "}
            {safeHtml(contactUs.requiredNote)}
          </p> */}

          <Form
            id="contactForm"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            className="contact-form"
          >
            <Row style={treasury} className="d-none">
              <Form.Group as={Col} sm={6} controlId="frca_name">
                <strong>
                  <Col sm={2}>&nbsp;</Col>
                  <Form.Label>* Rent Home Name: </Form.Label>
                </strong>
                <Form.Control
                  type="text"
                  minLength="2"
                  maxLength="12"
                  data-error="Please fill out this field correctly."
                />
                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm={6} controlId="frca_code">
                <strong>
                  <Col sm={2}>&nbsp;</Col>
                  <Form.Label>* Rent Code: </Form.Label>
                </strong>
                <Form.Control
                  type="text"
                  pattern="^[0-9a-zA-Z]{4}$"
                  maxLength="4"
                  data-error="Please fill out this field correctly."
                />
                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
              </Form.Group>
            </Row>

            <div className="contact-form__fields">
              <Form.Group controlId="frcName" className="contact-field">
                <Form.Control
                  type="text"
                  className="contact-input"
                  placeholder="Please enter your Name *"
                  pattern="^[a-zA-Z0-9-._' ][a-zA-Z0-9-._' ]+$"
                  onChange={(event) =>
                    setContactName(event.currentTarget.value)
                  }
                  autoComplete="off"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please fill out the field correctly
                </Form.Control.Feedback>
              </Form.Group>

              <Row className="g-3 contact-form__row">
                <Form.Group as={Col} xs={12} md={6} controlId="frcPhone" className="contact-field">
                  <Form.Control
                    type="text"
                    className="contact-input"
                    placeholder="Please enter your Telephone Number *"
                    minLength={14}
                    maxLength={21}
                    pattern="^\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})[ ]*(( |x){1}[ ]?([0-9]){1,7}){0,1}$"
                    onChange={handleTelephoneNumber}
                    autoComplete="off"
                    value={PhoneNumber}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please fill out the field correctly
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} xs={12} md={6} controlId="frcEmailAdd" className="contact-field">
                  <Form.Control
                    type="Email"
                    className="contact-input"
                    placeholder="Please enter your Email Address *"
                    pattern="^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]{2,64})$"
                    autoComplete="off"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please fill out the field correctly
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              {/* Address/City/State/Zip are hidden per the new Figma design (Name/Phone/Email/Message
                  only) but kept in the DOM, unstyled and untouched, so the backend payload shape
                  is unchanged and these fields can be shown again later if needed. */}
              <div style={treasury} className="d-none">
                <Form.Group controlId="frcAddress" className="contact-field">
                  <Form.Control
                    type="text"
                    className="contact-input"
                    placeholder="Please enter your Address"
                    autoComplete="off"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please fill out the field correctly
                  </Form.Control.Feedback>
                </Form.Group>

                <Row className="g-3 contact-form__row contact-form__row--triple">
                  <Form.Group as={Col} xs={12} md={5} controlId="frcCity" className="contact-field">
                    <Form.Select
                      className="contact-select"
                      value={city}
                      placeholder="Property City"
                      onChange={(e) => {
                        setCity(e.target.value);
                      }}
                    >
                      {cityOptions}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md={4} controlId="frcState" className="contact-field">
                    <Form.Select
                      className="contact-select"
                      value={state}
                      placeholder="Property State"
                      onChange={(e) => {
                        setState(e.target.value);
                      }}
                    >
                      <option value="">Your State</option>
                      {statesOptions}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    xs={12}
                    md={3}
                    controlId="frczipcode"
                    className="contact-field contact-field--zip"
                  >
                    <NumberFormat
                      className="form-control contact-input"
                      placeholder="Zip Code"
                      format="#####"
                      customInput={Form.Control}
                      value={zipCode}
                      displayType={"input"}
                      thousandSeparator={false}
                      fixedDecimalScale={true}
                      onValueChange={(values) => {
                        updateZipCode(values.value);
                      }}
                    />
                    {zipcodeError ? (
                      <p className="text-danger mb-0 contact-zip-error">
                        {zipcodeError}
                      </p>
                    ) : null}
                  </Form.Group>
                </Row>
              </div>

              <Form.Group controlId="frcMessage" className="contact-field">
                <Form.Control
                  as="textarea"
                  className="contact-textarea"
                  rows={3}
                  minLength={10}
                  placeholder="Please enter your message *"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please lengthen this text to 10 characters or more
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="contact-consent">
              <div className="contact-consent__header">
                <h2 className="contact-consent__title">
                  {safeHtml(contactUs.consent.title)}
                </h2>
                <hr className="contact-consent__divider" />
              </div>
              {contactUs.consent.paragraphs.map((paragraph, index) => (
                <p className="contact-consent__text" key={index}>
                  {safeHtml(paragraph)}
                </p>
              ))}
              <p className="contact-consent__note">
                {safeHtml(contactUs.consent.note)}
              </p>

              <Form.Group controlId="frcConsent" className="contact-consent__options">
                <div
                  className="contact-consent__option"
                  onClick={() => setConsent(true)}
                >
                  <Form.Check
                    type="checkbox"
                    className="contact-consent__checkbox"
                    checked={consent === true}
                    value={consent ? "I Consent" : "I Do Not Consent"}
                    readOnly
                  />
                  I Consent
                </div>
                <div
                  className="contact-consent__option"
                  onClick={() => setConsent(false)}
                >
                  <Form.Check
                    checked={consent === false}
                    type="checkbox"
                    className="contact-consent__checkbox"
                    value={consent ? "I Consent" : "I Do Not Consent"}
                    readOnly
                  />
                  I Do Not Consent
                </div>
              </Form.Group>
            </div>

            {showLoading ? (
              <div className="contact-submit-row">
                <Button
                  variant="secondary"
                  className="contact-submit-btn contact-submit-btn--loading"
                  disabled
                >
                  <span>
                    <Spinner
                      animation="border"
                      variant="warning"
                      role="status"
                      size="sm"
                    />
                  </span>{" "}
                  Please Wait...
                </Button>
              </div>
            ) : (
              <div className="contact-submit-row">
                <Button
                  type="submit"
                  className="contact-submit-btn"
                >
                  Submit <FaArrowRight className="contact-submit-btn__icon" />
                </Button>
              </div>
            )}
          </Form>
        </Col>
        </Row>
        </Container>
      </div>

      <Modal centered show={showTY} backdrop="static">
        <Modal.Body>
          <Card>
            <Card.Body>
              <Card.Text className="text-justify">
                Thank you <strong>{contactName}</strong>.<br />
                <br />
                We have received your request and will contact within 24 Hours.
                <br />
                <br />
                <Nav.Link as={Link} to="/" style={{ display: "contents" }}>
                  Click here to return to Home Page
                </Nav.Link>
              </Card.Text>
            </Card.Body>
            <Card.Footer className="text-right">
              <Button
                variant="info"
                onClick={() => {
                  setTYModal(false);
                  setValidated(false);
                }}
              >
                Close
              </Button>
            </Card.Footer>
          </Card>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        centered
        show={showFail}
        onHide={() => setFailModal(false)}
        backdrop="static"
      >
        <Modal.Body>
          Due to technical difficulties your request could not be sent. Please
          contact <a href="mailto:info@forrentca.com">info@forrentca.com</a>.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setFailModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default ContactUs;
